module.exports = __webpack_public_path__ + "media/images/components/c17-covid-19/info-19-4ede4464dad1e8cde6605c19b3bdfa44.svg";